import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "notification"
};
var _hoisted_2 = { class: "notification__inner" };
var _hoisted_3 = { class: "notification__left" };
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "notification__left-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "icon icon-alert-circle-colour icon--xs",
        "aria-hidden": "true"
    })
], -1 /* HOISTED */);
var _hoisted_5 = { class: "notification__left-content" };
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__label" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note" }, "Passengers")
], -1 /* HOISTED */);
var _hoisted_8 = { class: "cabininput__body" };
var _hoisted_9 = { class: "cabininput__input" };
var _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__input-info" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-body text--bold text-KQ-Grey1" }, "Adult"),
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note--sm" }, "Age 18+")
], -1 /* HOISTED */);
var _hoisted_11 = { class: "cabininput__input-controls" };
var _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_13 = [
    _hoisted_12
];
var _hoisted_14 = { class: "heading-h5" };
var _hoisted_15 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_16 = [
    _hoisted_15
];
var _hoisted_17 = { class: "cabininput__input" };
var _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__input-info" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-body text--bold text-KQ-Grey1" }, "Youth"),
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note--sm" }, "Age 12 - 17")
], -1 /* HOISTED */);
var _hoisted_19 = { class: "cabininput__input-controls" };
var _hoisted_20 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_21 = [
    _hoisted_20
];
var _hoisted_22 = { class: "heading-h5" };
var _hoisted_23 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_24 = [
    _hoisted_23
];
var _hoisted_25 = { class: "cabininput__input" };
var _hoisted_26 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__input-info" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-body text--bold text-KQ-Grey1" }, "Child"),
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note--sm" }, "Age 2 - 11")
], -1 /* HOISTED */);
var _hoisted_27 = { class: "cabininput__input-controls" };
var _hoisted_28 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_29 = [
    _hoisted_28
];
var _hoisted_30 = { class: "heading-h5" };
var _hoisted_31 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_32 = [
    _hoisted_31
];
var _hoisted_33 = { class: "cabininput__input" };
var _hoisted_34 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__input-info" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-body text--bold text-KQ-Grey1" }, "Infant"),
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note--sm" }, "Under 2 Years")
], -1 /* HOISTED */);
var _hoisted_35 = { class: "cabininput__input-controls" };
var _hoisted_36 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_37 = [
    _hoisted_36
];
var _hoisted_38 = { class: "heading-h5" };
var _hoisted_39 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_40 = [
    _hoisted_39
];
var _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__label" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note" }, "Cabin class")
], -1 /* HOISTED */);
var _hoisted_42 = { class: "cabininput__input" };
var _hoisted_43 = { id: "economyCabin" };
var _hoisted_44 = {
    key: 0,
    class: "icon icon-check icon-color--red icon--sm",
    "aria-hidden": "true"
};
var _hoisted_45 = { class: "cabininput__input" };
var _hoisted_46 = { id: "businessCabin" };
var _hoisted_47 = {
    key: 0,
    class: "icon icon-check icon-color--red icon--sm",
    "aria-hidden": "true"
};
var _hoisted_48 = { class: "cabininput__header" };
var _hoisted_49 = /*#__PURE__*/ _createElementVNode("p", null, "Select passengers and class", -1 /* HOISTED */);
var _hoisted_50 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-close icon--xs",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_51 = [
    _hoisted_50
];
var _hoisted_52 = {
    key: 0,
    class: "cabininput__mobile-error notification"
};
var _hoisted_53 = { class: "notification__inner" };
var _hoisted_54 = { class: "notification__left" };
var _hoisted_55 = /*#__PURE__*/ _createElementVNode("div", { class: "notification__left-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "icon icon-alert-circle-colour icon--xs",
        "aria-hidden": "true"
    })
], -1 /* HOISTED */);
var _hoisted_56 = { class: "notification__left-content" };
var _hoisted_57 = ["innerHTML"];
var _hoisted_58 = { class: "cabininput__mobile-content" };
var _hoisted_59 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__label" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note" }, "Passengers")
], -1 /* HOISTED */);
var _hoisted_60 = { class: "cabininput__body" };
var _hoisted_61 = { class: "cabininput__input" };
var _hoisted_62 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__input-info" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-body text--bold text-KQ-Grey1" }, "Adult"),
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note--sm" }, "Age 18+")
], -1 /* HOISTED */);
var _hoisted_63 = { class: "cabininput__input-controls" };
var _hoisted_64 = ["disabled", "aria-disabled"];
var _hoisted_65 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_66 = [
    _hoisted_65
];
var _hoisted_67 = { class: "heading-h5" };
var _hoisted_68 = ["disabled", "aria-disabled"];
var _hoisted_69 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_70 = [
    _hoisted_69
];
var _hoisted_71 = { class: "cabininput__input" };
var _hoisted_72 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__input-info" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-body text--bold text-KQ-Grey1" }, "Youth"),
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note--sm" }, "Age 12 - 17")
], -1 /* HOISTED */);
var _hoisted_73 = { class: "cabininput__input-controls" };
var _hoisted_74 = ["disabled", "aria-disabled"];
var _hoisted_75 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_76 = [
    _hoisted_75
];
var _hoisted_77 = { class: "heading-h5" };
var _hoisted_78 = ["disabled", "aria-disabled"];
var _hoisted_79 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_80 = [
    _hoisted_79
];
var _hoisted_81 = { class: "cabininput__input" };
var _hoisted_82 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__input-info" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-body text--bold text-KQ-Grey1" }, "Child"),
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note--sm" }, "Age 2 - 11")
], -1 /* HOISTED */);
var _hoisted_83 = { class: "cabininput__input-controls" };
var _hoisted_84 = ["disabled", "aria-disabled"];
var _hoisted_85 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_86 = [
    _hoisted_85
];
var _hoisted_87 = { class: "heading-h5" };
var _hoisted_88 = ["disabled", "aria-disabled"];
var _hoisted_89 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_90 = [
    _hoisted_89
];
var _hoisted_91 = { class: "cabininput__input" };
var _hoisted_92 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__input-info" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-body text--bold text-KQ-Grey1" }, "Under 2 Years"),
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note--sm" }, "Age 0 - 1, on lap")
], -1 /* HOISTED */);
var _hoisted_93 = { class: "cabininput__input-controls" };
var _hoisted_94 = ["disabled", "aria-disabled"];
var _hoisted_95 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_96 = [
    _hoisted_95
];
var _hoisted_97 = { class: "heading-h5" };
var _hoisted_98 = ["disabled", "aria-disabled"];
var _hoisted_99 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_100 = [
    _hoisted_99
];
var _hoisted_101 = /*#__PURE__*/ _createElementVNode("div", { class: "cabininput__label" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note" }, "Cabin class")
], -1 /* HOISTED */);
var _hoisted_102 = { class: "cabininput__input" };
var _hoisted_103 = { id: "economyCabin" };
var _hoisted_104 = {
    key: 0,
    class: "icon icon-check icon-color--red icon--sm",
    "aria-hidden": "true"
};
var _hoisted_105 = { class: "cabininput__input" };
var _hoisted_106 = { id: "businessCabin" };
var _hoisted_107 = {
    key: 0,
    class: "icon icon-check icon-color--red icon--sm",
    "aria-hidden": "true"
};
var _hoisted_108 = { class: "cabininput__footer" };
var _hoisted_109 = ["disabled"];
import { ref } from 'vue';
import { useIsMobile } from '../../hooks/useIsMobile';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CabinInputContent',
    props: {
        isExpanded: {
            type: Boolean,
            default: false,
        },
        errorMsg: {
            type: String,
            default: '',
        },
        inputValues: {
            type: Object,
            default: function () { return ({
                adults: 1,
                youth: 0,
                child: 0,
                infant: 0,
                cabin: 'economy',
            }); },
        },
        handleUpdateValues: {
            type: Function,
            default: function () { },
        },
        toggleDropDown: {
            type: Function,
            default: function () { },
        },
        totalPassengers: {
            type: Number,
            default: 1,
        },
        handleResetValues: {
            type: Function,
            default: function () { },
        },
    },
    setup: function (__props) {
        var props = __props;
        var contentRef = ref();
        var isMobile = useIsMobile();
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (__props.isExpanded && !_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "cabininputContent",
                        ref_key: "contentRef",
                        ref: contentRef,
                        class: "cabininput__content",
                        role: "dialog",
                        "aria-labelledby": "selectedPassengersCabin"
                    }, [
                        (__props.errorMsg !== '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _hoisted_4,
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("p", { innerHTML: __props.errorMsg }, null, 8 /* PROPS */, _hoisted_6)
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("button", {
                                        "aria-label": "Decrease adult passengers",
                                        class: _normalizeClass(["button button--icon button--round button--primary", { disabled: __props.inputValues.adults === 0 }]),
                                        onClick: _cache[0] || (_cache[0] =
                                            function () {
                                                __props.handleUpdateValues('adults', __props.inputValues.adults - 1);
                                            })
                                    }, _hoisted_13, 2 /* CLASS */),
                                    _createElementVNode("p", _hoisted_14, _toDisplayString(__props.inputValues.adults), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                        "aria-label": "Increase adult passengers",
                                        class: _normalizeClass(["button button--icon button--round button--primary", { disabled: __props.totalPassengers >= 9 }]),
                                        onClick: _cache[1] || (_cache[1] =
                                            function () {
                                                __props.handleUpdateValues('adults', __props.inputValues.adults + 1);
                                            })
                                    }, _hoisted_16, 2 /* CLASS */)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _hoisted_18,
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("button", {
                                        "aria-label": "Decrease youth passengers",
                                        class: _normalizeClass(["button button--icon button--round button--primary", { disabled: __props.inputValues.youth === 0 }]),
                                        onClick: _cache[2] || (_cache[2] =
                                            function () {
                                                __props.handleUpdateValues('youth', __props.inputValues.youth - 1);
                                            })
                                    }, _hoisted_21, 2 /* CLASS */),
                                    _createElementVNode("p", _hoisted_22, _toDisplayString(__props.inputValues.youth), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                        "aria-label": "Increased youth passengers",
                                        class: _normalizeClass(["button button--icon button--round button--primary", { disabled: __props.totalPassengers >= 9 }]),
                                        onClick: _cache[3] || (_cache[3] =
                                            function () {
                                                __props.handleUpdateValues('youth', __props.inputValues.youth + 1);
                                            })
                                    }, _hoisted_24, 2 /* CLASS */)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("button", {
                                        "aria-label": "Decrease child passengers",
                                        class: _normalizeClass(["button button--icon button--round button--primary", { disabled: __props.inputValues.child === 0 }]),
                                        onClick: _cache[4] || (_cache[4] =
                                            function () {
                                                __props.handleUpdateValues('child', __props.inputValues.child - 1);
                                            })
                                    }, _hoisted_29, 2 /* CLASS */),
                                    _createElementVNode("p", _hoisted_30, _toDisplayString(__props.inputValues.child), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                        "aria-label": "Increment child passengers",
                                        class: _normalizeClass(["button button--icon button--round button--primary", { disabled: __props.totalPassengers >= 9 }]),
                                        onClick: _cache[5] || (_cache[5] =
                                            function () {
                                                __props.handleUpdateValues('child', __props.inputValues.child + 1);
                                            })
                                    }, _hoisted_32, 2 /* CLASS */)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("button", {
                                        "aria-label": "Decrease",
                                        class: _normalizeClass(["button button--icon button--round button--primary", { disabled: __props.inputValues.infant === 0 }]),
                                        onClick: _cache[6] || (_cache[6] =
                                            function () {
                                                __props.handleUpdateValues('infant', __props.inputValues.infant - 1);
                                            })
                                    }, _hoisted_37, 2 /* CLASS */),
                                    _createElementVNode("p", _hoisted_38, _toDisplayString(__props.inputValues.infant), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                        "aria-label": "Increment",
                                        class: _normalizeClass(["button button--icon button--round button--primary", {
                                                disabled: __props.inputValues.adults === 0 ||
                                                    __props.inputValues.infant >= __props.inputValues.adults,
                                            }]),
                                        onClick: _cache[7] || (_cache[7] =
                                            function () {
                                                __props.handleUpdateValues('infant', __props.inputValues.infant + 1);
                                            })
                                    }, _hoisted_40, 2 /* CLASS */)
                                ])
                            ]),
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("label", _hoisted_43, [
                                    _createElementVNode("input", {
                                        value: "economy",
                                        type: "radio",
                                        name: "cabin",
                                        "aria-labelledby": "economyCabin",
                                        onClick: _cache[8] || (_cache[8] =
                                            function () {
                                                __props.handleUpdateValues('cabin', 'economy');
                                            })
                                    }),
                                    _createTextVNode(" Economy "),
                                    (__props.inputValues.cabin === 'economy')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("label", _hoisted_46, [
                                    _createElementVNode("input", {
                                        value: "business",
                                        type: "radio",
                                        name: "cabin",
                                        "aria-labelledby": "businessCabin",
                                        onClick: _cache[9] || (_cache[9] =
                                            function () {
                                                __props.handleUpdateValues('cabin', 'business');
                                            })
                                    }),
                                    _createTextVNode(" Business "),
                                    (__props.inputValues.cabin === 'business')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_47))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ])
                    ], 512 /* NEED_PATCH */))
                    : _createCommentVNode("v-if", true),
                (__props.isExpanded && _unref(isMobile))
                    ? (_openBlock(), _createBlock(_Teleport, {
                        key: 1,
                        to: "body"
                    }, [
                        _createElementVNode("div", {
                            id: "cabininputContent",
                            ref_key: "contentRef",
                            ref: contentRef,
                            class: "cabininput__content cabininput__content--overflowed cabininput__content--full",
                            role: "dialog",
                            "aria-labelledby": "selectedPassengersCabin"
                        }, [
                            _createElementVNode("div", _hoisted_48, [
                                _hoisted_49,
                                _createElementVNode("button", {
                                    role: "button",
                                    "aria-label": "Dismiss modal",
                                    class: "button--text button--icon base-model__header-close",
                                    onClick: _cache[10] || (_cache[10] =
                                        function () {
                                            __props.toggleDropDown();
                                        })
                                }, _hoisted_51)
                            ]),
                            (__props.errorMsg !== '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("div", _hoisted_54, [
                                            _hoisted_55,
                                            _createElementVNode("div", _hoisted_56, [
                                                _createElementVNode("p", { innerHTML: __props.errorMsg }, null, 8 /* PROPS */, _hoisted_57)
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_58, [
                                _hoisted_59,
                                _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("div", _hoisted_61, [
                                        _hoisted_62,
                                        _createElementVNode("div", _hoisted_63, [
                                            _createElementVNode("button", {
                                                "aria-label": "Decrease adult passengers",
                                                class: "button button--icon button--round button--primary",
                                                disabled: __props.inputValues.adults === 0,
                                                "aria-disabled": __props.inputValues.adults === 0,
                                                onClick: _cache[11] || (_cache[11] =
                                                    function () {
                                                        __props.handleUpdateValues('adults', __props.inputValues.adults - 1);
                                                    })
                                            }, _hoisted_66, 8 /* PROPS */, _hoisted_64),
                                            _createElementVNode("p", _hoisted_67, _toDisplayString(__props.inputValues.adults), 1 /* TEXT */),
                                            _createElementVNode("button", {
                                                "aria-label": "Increase adult passengers",
                                                class: "button button--icon button--round button--primary",
                                                disabled: __props.totalPassengers >= 9,
                                                "aria-disabled": __props.totalPassengers >= 9,
                                                onClick: _cache[12] || (_cache[12] =
                                                    function () {
                                                        __props.handleUpdateValues('adults', __props.inputValues.adults + 1);
                                                    })
                                            }, _hoisted_70, 8 /* PROPS */, _hoisted_68)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_71, [
                                        _hoisted_72,
                                        _createElementVNode("div", _hoisted_73, [
                                            _createElementVNode("button", {
                                                "aria-label": "Decrease youth passengers",
                                                class: "button button--icon button--round button--primary",
                                                disabled: __props.inputValues.youth === 0,
                                                "aria-disabled": __props.inputValues.youth === 0,
                                                onClick: _cache[13] || (_cache[13] =
                                                    function () {
                                                        __props.handleUpdateValues('youth', __props.inputValues.youth - 1);
                                                    })
                                            }, _hoisted_76, 8 /* PROPS */, _hoisted_74),
                                            _createElementVNode("p", _hoisted_77, _toDisplayString(__props.inputValues.youth), 1 /* TEXT */),
                                            _createElementVNode("button", {
                                                "aria-label": "Increased youth passengers",
                                                class: "button button--icon button--round button--primary",
                                                disabled: __props.totalPassengers >= 9,
                                                "aria-disabled": __props.totalPassengers >= 9,
                                                onClick: _cache[14] || (_cache[14] =
                                                    function () {
                                                        __props.handleUpdateValues('youth', __props.inputValues.youth + 1);
                                                    })
                                            }, _hoisted_80, 8 /* PROPS */, _hoisted_78)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_81, [
                                        _hoisted_82,
                                        _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("button", {
                                                "aria-label": "Decrease child passengers",
                                                class: "button button--icon button--round button--primary",
                                                disabled: __props.inputValues.child === 0,
                                                "aria-disabled": __props.inputValues.child === 0,
                                                onClick: _cache[15] || (_cache[15] =
                                                    function () {
                                                        __props.handleUpdateValues('child', __props.inputValues.child - 1);
                                                    })
                                            }, _hoisted_86, 8 /* PROPS */, _hoisted_84),
                                            _createElementVNode("p", _hoisted_87, _toDisplayString(__props.inputValues.child), 1 /* TEXT */),
                                            _createElementVNode("button", {
                                                "aria-label": "Increment child passengers",
                                                class: "button button--icon button--round button--primary",
                                                disabled: __props.inputValues.adults === 0 || __props.totalPassengers >= 9,
                                                "aria-disabled": __props.inputValues.adults === 0 || __props.totalPassengers >= 9,
                                                onClick: _cache[16] || (_cache[16] =
                                                    function () {
                                                        __props.handleUpdateValues('child', __props.inputValues.child + 1);
                                                    })
                                            }, _hoisted_90, 8 /* PROPS */, _hoisted_88)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_91, [
                                        _hoisted_92,
                                        _createElementVNode("div", _hoisted_93, [
                                            _createElementVNode("button", {
                                                "aria-label": "Decrease",
                                                class: "button button--icon button--round button--primary",
                                                disabled: __props.inputValues.infant === 0,
                                                "aria-disabled": __props.inputValues.infant === 0,
                                                onClick: _cache[17] || (_cache[17] =
                                                    function () {
                                                        __props.handleUpdateValues('infant', __props.inputValues.infant - 1);
                                                    })
                                            }, _hoisted_96, 8 /* PROPS */, _hoisted_94),
                                            _createElementVNode("p", _hoisted_97, _toDisplayString(__props.inputValues.infant), 1 /* TEXT */),
                                            _createElementVNode("button", {
                                                "aria-label": "Increment",
                                                class: "button button--icon button--round button--primary",
                                                disabled: __props.inputValues.adults === 0 ||
                                                    __props.inputValues.infant >= __props.inputValues.adults,
                                                "aria-disabled": __props.inputValues.adults === 0 ||
                                                    __props.inputValues.infant >= __props.inputValues.adults,
                                                onClick: _cache[18] || (_cache[18] =
                                                    function () {
                                                        __props.handleUpdateValues('infant', __props.inputValues.infant + 1);
                                                    })
                                            }, _hoisted_100, 8 /* PROPS */, _hoisted_98)
                                        ])
                                    ]),
                                    _hoisted_101,
                                    _createElementVNode("div", _hoisted_102, [
                                        _createElementVNode("label", _hoisted_103, [
                                            _createElementVNode("input", {
                                                value: "economy",
                                                type: "radio",
                                                name: "cabin",
                                                "aria-labelledby": "economyCabin",
                                                onClick: _cache[19] || (_cache[19] =
                                                    function () {
                                                        __props.handleUpdateValues('cabin', 'economy');
                                                    })
                                            }),
                                            _createTextVNode(" Economy "),
                                            (__props.inputValues.cabin === 'economy')
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_104))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_105, [
                                        _createElementVNode("label", _hoisted_106, [
                                            _createElementVNode("input", {
                                                value: "business",
                                                type: "radio",
                                                name: "cabin",
                                                "aria-labelledby": "businessCabin",
                                                onClick: _cache[20] || (_cache[20] =
                                                    function () {
                                                        __props.handleUpdateValues('cabin', 'business');
                                                    })
                                            }),
                                            _createTextVNode(" Business "),
                                            (__props.inputValues.cabin === 'business')
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_107))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_108, [
                                        _createElementVNode("button", {
                                            class: "button button--text",
                                            onClick: _cache[21] || (_cache[21] =
                                                function () {
                                                    __props.handleResetValues();
                                                    __props.toggleDropDown();
                                                })
                                        }, " Cancel "),
                                        _createElementVNode("button", {
                                            class: "button",
                                            disabled: __props.errorMsg !== '',
                                            onClick: _cache[22] || (_cache[22] =
                                                function () {
                                                    __props.toggleDropDown();
                                                })
                                        }, " Done ", 8 /* PROPS */, _hoisted_109)
                                    ])
                                ])
                            ])
                        ], 512 /* NEED_PATCH */)
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
